import { render, staticRenderFns } from "./company-feed.vue?vue&type=template&id=bda57cc2"
import script from "./company-feed.vue?vue&type=script&lang=js"
export * from "./company-feed.vue?vue&type=script&lang=js"
import style0 from "./company-feed.vue?vue&type=style&index=0&id=bda57cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports